import { useMutation } from '@tanstack/react-query';

import useApi from '@/hooks/useApi/useApi';

type EnterTrialParams = {
  name: string;
  title: string;
  dpa_accepted: boolean;
  subscription_terms_accepted: boolean;
};

export const useEnterTrial = () => {
  const { axiosInstance } = useApi();
  return useMutation({
    mutationFn: async (params: EnterTrialParams) => {
      const { data } = await axiosInstance.post('/api/v1/company/enter_trial', params);
      return data;
    },
  });
};
